import { NavLink, Route, Routes } from "react-router-dom";
import { cn } from "./lib/cn";
import { DashboardLayout } from "./components/layout/DashboardLayout";
import { UsersPanel } from "./features/admin/UsersPanel";
import { AccountChip } from "./features/auth/AccountChip";
import { AuthGate } from "./features/auth/AuthGate";
import { useAuthStore } from "./lib/auth/authStore";
import { Dashboard } from "./pages/Dashboard";

function navClass({ isActive }: { isActive: boolean }): string {
	return cn(
		"rounded-md px-3 py-1.5 transition",
		isActive
			? "bg-slate-800 text-slate-100"
			: "text-slate-400 hover:text-slate-200",
	);
}

export function App() {
	const isAdmin = useAuthStore((s) => s.user?.role === "admin");

	return (
		<DashboardLayout>
			<div className="mb-4 flex items-center justify-between gap-3">
				<nav className="flex items-center gap-1 text-sm">
					<NavLink to="/" end className={navClass}>
						Dashboard
					</NavLink>
					{isAdmin && (
						<NavLink to="/admin/users" className={navClass}>
							Users
						</NavLink>
					)}
				</nav>
				<AccountChip />
			</div>
			<AuthGate>
				<Routes>
					<Route path="/" element={<Dashboard />} />
					<Route path="/admin/users" element={<UsersPanel />} />
				</Routes>
			</AuthGate>
		</DashboardLayout>
	);
}
